<template>
  <div>
    <b-table striped hover :items="items"></b-table>
  </div>
</template>

<script>
import db from './firebaseInit'
export default {
  data () {
    return {
      items: [],
      loading: true
    }
  },
  methods: {
    getUsers () {
      db.collection('users').get().then((querySnapshot) => {
        this.loading = false
        querySnapshot.forEach((doc) => {
          let data = {
            'id': doc.id,
            'name': doc.data().fullname,
            'email': doc.data().email
          }
          console.log('User: ' + JSON.stringify(data))
          this.items.push(data)
        })
      })
    }
  },
  beforeMount () {
    this.getUsers()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Users.vue